import React from 'react';
import { Actions } from '../../core/modules/Actions';
import { ModuleEvents } from './Actions';
import { onToast } from '../../core/Constant';
import { navigateTo } from '../../core/services/NavigationServicd';
import _ from "lodash";

export default {
  [ModuleEvents.STD_START_QUIZ]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
      const isResume     = payload?.data?.is_resume;
      const lastQId      = payload?.data?.last_question_id;
      const firstQId     = payload?.data?.first_question_id;
      const quizId       = payload?.data?.quiz_id;
  
      const qId = (isResume && lastQId) ? lastQId : firstQId;
  
      dispatch(Actions.quizes.getAQuestionOfQuiz({qId, quizId, time_spent: payload?.data?.time_spent }))
    }
    else {
      onToast('Quiz  Error', payload, false);
    }
  },
  [ModuleEvents.STD_STUDENT_ANSWERS]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
      // 
      dispatch(Actions.quizes.getAQuestionOfQuiz(payload?.nextData))
    }
    else {
      onToast('Quiz  Error', payload, false);
    }
  },

  [ModuleEvents.DELETE_QUIZE]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizeList());
    }
    onToast('Delete Quiz', payload, false);

  },

  [ModuleEvents.UPDATE_QUIZ_STATE]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizeList());
    }
    onToast('Update Quiz', payload, false);

  },

  [ModuleEvents.CREATE_QUIZE]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizeList());
      localStorage.setItem('newQuiz', JSON.stringify(_.get(payload, 'data', {})));
      navigateTo('/admin-quiz-second');
    }
    onToast('Create Quiz', payload, false);

  },

  [ModuleEvents.CREATE_QUIZ_FOLDER]: ({ dispatch, payload }) => {
    onToast('Create Folder', payload, false);
  },

  [ModuleEvents.CREATE_QUESTION]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizQuestionAndAnswerByQuizId(payload?.quizId));
    }
    onToast('Create Question', payload, false);

  },

  [ModuleEvents.DELETE_QUESTION]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizQuestionAndAnswerByQuizId(payload?.quizId));
    }
    onToast('Delete Question', payload, false);

  },

  [ModuleEvents.ADD_FEEDBACK_QUIZ_ADMIN]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {

    }
    onToast('Add Feedback', payload, false);
  },

  [ModuleEvents.STD_COMPLETE_QUIZ]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      let breadcrumbTrail;
      try {
        breadcrumbTrail = JSON.parse(sessionStorage.getItem('std_quiz_breadcrumb_trail'));
      } catch (e) {
        breadcrumbTrail = undefined;
      }
      let selectedCourse;
      try {
        selectedCourse = JSON.parse(sessionStorage.getItem('std_quiz_selected_course'));
      } catch (e) {
        selectedCourse = undefined;
      }
      navigateTo('/quiz-attempt', { state: { quiz: { id: payload?.data.quiz_id, name: payload?.data.quiz_name }, breadcrumbTrail, selectedCourse } });
      const qD = localStorage.getItem('quiz');
      const dataList = JSON.parse(qD);
      const list = _.filter(dataList, item => item.quizId != payload?.quizId);
      localStorage.setItem('quiz', JSON.stringify(list));
      localStorage.removeItem('currentQuestion')
    }
    onToast('Submit quiz', payload, false);
  },

  [ModuleEvents.DELETE_ATTEMPT]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizSumbissionHistory());
    }
    onToast('Delete Attempt', payload, false);

  },

  [ModuleEvents.STD_GET_QUIZ_LIST]: ({ dispatch, payload, appState }) => {
    if (payload == undefined || payload.status_code == 0) {
      onToast('Quiz Load Attempt Failed Please Select Course');
    }
  },

  [ModuleEvents.UPDATE_QUIZ_ADMIN]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizeList());
      localStorage.setItem('newQuiz', JSON.stringify(_.get(payload, 'data', {})));
      navigateTo('/admin-quiz-edit-second');
    }
    onToast('Update Quiz', payload, false);

  },

  [ModuleEvents.UPDATE_QUESTION_ADMIN]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizQuestionAndAnswerByQuizId(payload?.quizId));
    }
    onToast('Update Question', payload, false);

  },

  [ModuleEvents.RESET_QUIZ_ATTEMPT_BY_ADMIN]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.getQuizSumbissionHistory());
    }
    onToast('Reset Quiz attempt', payload, false);
  },

  [ModuleEvents.RESET_ALL_QUIZ_ATTEMPTS]: ({ dispatch, payload, appState }) => {
    // Show toast for bulk/all attempts reset via email (admin/quiz/resetAllAttempts)
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      // Optionally refresh current list if applicable
      dispatch(Actions.quizes.getQuizSumbissionHistory());
    }
    onToast('Reset Quiz Attempts', payload, false);
  },

  [ModuleEvents.GET_A_QUESTION_OF_QUIZ_BY_QID]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      
    }else{
      onToast('No Attempts', payload, false);
      navigateTo('/quiz')
    }
    

  },
  [ModuleEvents.ADD_QUESTION_TO_QUIZ ]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {  
      // Refresh the question list after adding question to quiz
      const quizId = payload?.params?.quiz_id;
      if (quizId) {
        // Add a delay to ensure the backend has processed the addition
        setTimeout(() => {
          dispatch(Actions.quizes.getQuizQuestionAndAnswerByQuizId(quizId));
        }, 800);
      }
    }
    onToast('Questions Add', payload, false);
  },
  [ModuleEvents.REMOVE_QUESTION_FROM_QUIZ ]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {  
     dispatch(Actions.quizes.getQuizQuestionAndAnswerByQuizId(payload?.params.
      quiz_id
      ));
    }
    onToast('Questions Remove', payload, false);
  },
  [ModuleEvents.ADD_GRADES]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
      dispatch(Actions.quizes.fetchGrades({
        quiz_id
        : payload?.params.
        quiz_id , category_id : payload?.params.category_id
        }));
    }
    onToast('Grade Add', payload, false);
  },
  [ModuleEvents.UPDATE_GRADES]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status && payload.status_code == 1) {
 
    }
    onToast('Update Grade', payload, false);
  },

  [ModuleEvents.DOWNLOAD_QUIZ_SCORES_CSV]: ({ dispatch, payload, appState }) => {
    if (payload && payload.success && !payload.error) {
      onToast('CSV Download', { status: true, status_code: 1, message: 'Quiz scores CSV downloaded successfully!' }, false);
    } else {
      const errorMessage = payload?.error || payload?.message || 'Failed to download CSV file. Please try again.';
      onToast('CSV Download Failed', { status: false, status_code: 0, message: errorMessage }, false);
    }
  },

  [ModuleEvents.SAVE_MISTAKE_LOG]: ({ payload }) => {
    onToast('Save Mistake Log', payload, false);
  },

  [ModuleEvents.UPDATE_MISTAKE_LOG]: ({ payload }) => {
    onToast('Update Mistake Log', payload, false);
  },


};



